import { NOT_SET } from '@/app/lib/analytics/constants'
import { slugify } from '@/app/lib/analytics/dataLayer'
import type { PageContext } from '@/app/lib/analytics/types'
import { ALL_LOCATIONS } from '@/app/lib/constants'

/** Mismo enum `plp` que agenda/lo-mas-vendido/promociones/categoría (`analytic-variables.md`). */
export const ANALYTICS_PAGE_TYPE = 'plp'

/**
 * Contexto de página GA4 de la PLP de subcategoría
 * (`/entradas/{categoria}/{location}/{subcategoria}/`, guía 02 §3).
 * `business_unit`/`page_location` los completa el provider en cada push.
 *
 * ⚠️ PROVISIONAL — pendiente de confirmar con Analítica:
 * - `page_subtype`: el enum no define un valor para subcategoría. Se aplica el
 *   criterio de agenda/promociones: `ciudad` con provincia, `not_set` con
 *   `todos`.
 * - `page_hierarchy`: `categoria/location/subcategoria`, espejo de la URL
 *   (el ejemplo del diccionario `conciertos/madrid` es solo de 2 niveles).
 */
export function buildSubcategoriaAnalyticsContext(
  categoria: string,
  location: string,
  subcategoria: string,
): PageContext {
  const cat = slugify(categoria)
  const loc = slugify(location)
  const sub = slugify(subcategoria)
  return {
    page_title: `entradas_el_corte_ingles_-_${cat}_${sub}`,
    page_type: ANALYTICS_PAGE_TYPE,
    page_subtype: location === ALL_LOCATIONS ? NOT_SET : 'ciudad',
    page_hierarchy: `${cat}/${loc}/${sub}`,
    page_brand: NOT_SET,
    page_brand_type: NOT_SET,
  }
}
